import { useEffect } from "react";
import { useLocation } from "wouter";

export default function RegisterAgentRedirect() {
  const [, navigate] = useLocation();
  useEffect(() => {
    navigate("/auth?tab=register&role=agent", { replace: true });
  }, [navigate]);
  return null;
} 